// extracted by mini-css-extract-plugin
module.exports = {"eligibilityTag":"eligibilityTag_eligibilityTag__3hjao"};